export interface ChangelogRelease {
  version: string;
  date?: string;
  entries: string[];
}

export interface ChangelogMajor {
  version: number;
  minors: { version: string; releases: ChangelogRelease[] }[];
}

/** Read release sections, preserving Markdown paragraphs and multi-line bullets. */
export function parseChangelog(source: string): { development: string[]; majors: ChangelogMajor[] } {
  const development: string[] = [];
  const releases: ChangelogRelease[] = [];
  let entries: string[] | undefined;
  let continuation = false;
  for (const line of source.replace(/\r\n?/g, '\n').split('\n')) {
    if (/^##\s/.test(line)) {
      const release = line.match(/^##\s+\[?v?(\d+\.\d+\.\d+)\]?(?:\s+-\s+(\d{4}-\d{2}-\d{2}))?\s*$/);
      if (release) {
        const item = { version: release[1], date: release[2], entries: [] as string[] };
        releases.push(item);
        entries = item.entries;
      } else entries = /^## Development\s*$/.test(line) ? development : undefined;
      continuation = false;
    } else if (entries && line.trim()) {
      const bullet = line.match(/^\s*[-*]\s+(.*)/);
      if (bullet) { entries.push(bullet[1]); continuation = true; }
      else if (continuation && /^\s+/.test(line)) entries[entries.length - 1] += ` ${line.trim()}`;
      else { entries.push(line.replace(/^#{3,6}\s+/, '')); continuation = false; }
    } else continuation = false;
  }
  releases.sort((a, b) => {
    const left = a.version.split('.').map(Number);
    const right = b.version.split('.').map(Number);
    return right[0] - left[0] || right[1] - left[1] || right[2] - left[2];
  });
  const majors: ChangelogMajor[] = [];
  for (const release of releases) {
    const [major, minor] = release.version.split('.');
    let group = majors.find(item => item.version === Number(major));
    if (!group) { group = { version: Number(major), minors: [] }; majors.push(group); }
    const key = `${major}.${minor}`;
    let subgroup = group.minors.find(item => item.version === key);
    if (!subgroup) { subgroup = { version: key, releases: [] }; group.minors.push(subgroup); }
    subgroup.releases.push(release);
  }
  return { development, majors };
}
